module.exports = __webpack_public_path__ + "./assets/icons/ou-peut-on-faire-voler-un-drone-en-france.jpg";